<template>
  <div>
    <div v-if="$root.$i18n.locale === 'en'" class="error">
      <h3>Translation Missing</h3>
      <p>We apologize that this page has not been translated yet.</p>
    </div>
    <article class="accent-didi">
      <header>
        <h2>Postkarte an Didi</h2>
      </header>
      <main>
        <p>
          Falls du konkrete Fragen zur Party hast, melde dich gerne direkt bei uns mithilfe dieses Kontaktformulars!
        </p>
        <p>Bitte beachte unsere <router-link :to="{name: 'privacy'}">Datenschutzhinweise</router-link> bevor du deine persönlichen Daten an uns übermittelst.</p>
        <div v-if="error">
          <p>Bei der Übermittlung ist ein Fehler aufgetreten:</p>
          <p>{{error}}</p>
        </div>
      </main>
    </article>

    <div class="postcard" style="margin: 4em auto;">
      <template v-if="submitting">
        <p>Bitte warte einen kleinen Moment, bis deine Nachricht bei uns angekommen ist...</p>
      </template>
      <template v-else-if="success">
        <p class="success">Deine Karte ist angekommen.<br>Ich werde mich bald bei dir melden!</p>
      </template>
      <template v-else>
        <div class="message">
          <div>
            <p>
              Hallo Didi,
            </p>
            <textarea v-model="message" style="width: 100%; box-sizing: border-box"></textarea>
            <p>
              Dein <input type="text" v-model="name">
            </p>
            <hr>
            <p>
              Bitte antworte mir per E-Mail:
              <input type="email" v-model="email">
            </p>
          </div>
        </div>
        <div class="destination">
          <div class="stamp-dropzone"></div>
          <div class="contact">
            An:<br>
            <strong>Dietmar Dax</strong><br>
            <div class="placeholder" style="width: 75%"></div>
            <br>
            <div class="placeholder" style="width: 30%"></div>&nbsp;
            <div class="placeholder" style="width: 50%"></div>
          </div>
          <div class="expand"></div>
          <div style="text-align: right; padding-top: 1em;">
            <button v-if="valid" @click="submitMessage">Abschicken</button>
            <button v-else disabled>Bitte fülle zuerst alle Felder aus</button>
          </div>
        </div>
      </template>
    </div>

    <newsletter style="margin-bottom: 7em"></newsletter>
  </div>
</template>


<script>
  const axios = require('axios');
  import Newsletter from "../components/Newsletter";

  export default {
    components: { Newsletter },
    data() {
      return {
        email: null,
        error: null,
        message: null,
        name: null,
        submitting: false,
        success: null,
      }
    },
    computed: {
      emailValid() {
        let re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])/;
        return this.email && this.email.match(re);
      },
      valid() {
        return this.emailValid && this.name && this.message;
      }
    },
    methods: {
      submitMessage() {
        this.submitting = true;
        axios
          .post('https://contact.frechdax-abdl.de/api/contact/postcard', {
            email: this.email,
            name: this.name,
            message: this.message
          })
          .then(response => response.data)
          .then(() => {
            this.success = true;
          })
          .catch(error => {
            this.error = error;
          })
          .finally(() => {
            this.submitting = false;
          });
      }
    }
  }
</script>


<style scoped lang="scss">
  $postcardBaseColor: #fdd835;

  .postcard {
    display: grid;
    background: linear-gradient(-30deg, #F06292 20%, #fdd835 80%);
    // background: #1976d2;
    border-radius: 8px;
    color: black;
    grid-template-columns: 2fr 1fr;
    grid-gap: 40px;
    padding: 20px;
    width: 700px;
    box-shadow: 0 2px 12px rgba(black, 0.2);
    color: black;
    font-weight: bold;

    p {
      padding: 0 8px;
    }

    input, textarea {
      border: 1px dashed white;
      background: white;
      box-shadow: none;
      border-radius: 8px;
      padding: 4px 8px;
      vertical-align: middle;
      font-weight: bold;
      max-width: 100%;
    }

    .message textarea {
      height: 200px;
      width: 100%;
      color: black;
      font-weight: bold;
      font-family: "Open Sans";
      resize: vertical;
    }

    .expand {
      flex-grow: 1;
    }

    .destination {
      text-align: right;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .stamp-dropzone {
        background: rgba(white, 0.2);
        width: 80px;
        height: 100px;
        display: inline-block;
      }

      .contact {
        text-align: left;
        margin-top: 80px;
        width: 100%;

        .placeholder {
          height: 1.5em;
          background: rgba(white, 0.2);
          display: inline-block;
          margin-top: 0.5em;
        }
      }
    }

    hr {
      background: rgba(white, 0.4);
      border: 0;
      height: 2px;
    }


    @media screen and (max-width: 1000px) {
      display: block;
      width: 100%;
      box-sizing: border-box;
      padding: 20px;

      .message {
        width: 100%;
        box-sizing: border-box;
      }

      .destination {
        .stamp-dropzone, .contact .placeholder {
          display: none;
        }
      }
    }
  }
</style>
